/**
 * Route for `manage-campaign-section-centralized-dashboard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ManageCampaignSectionCentralizedDashboardPage } from "../features/manage-campaign-section-centralized-dashboard/ManageCampaignSectionCentralizedDashboardPage";

export const manageCampaignSectionCentralizedDashboardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/manage-campaign-section-centralized-dashboard",
	component: ManageCampaignSectionCentralizedDashboardPage,
});

export default manageCampaignSectionCentralizedDashboardRoute;
